module.exports = __webpack_public_path__ + "img/20191018162912360截图20191018152439296.f5f0a0d9.jpg";